/**
 * Keeper's documented opt-out: a field carrying this class gets no KeeperFill lock icon.
 *
 * It has to sit on the `<input>` element itself, not a wrapper, so with AntD components pass it
 * through the semantic slot - `classNames={{input: KEEPER_IGNORE_CLASS}}` - rather than
 * `className`, which lands on the outer container.
 *
 * See https://docs.keeper.io/en/user-guides/troubleshooting/website-developers
 */
export const KEEPER_IGNORE_CLASS = 'keeper-ignore';
